import Vue from 'vue';
import {
    initialState
} from '../dataStructures';
export default {
    user(state, user) {
        state.user = user;
    },
    client(state, client) {
        state.client = client;
    },
    venue(state, venue) {
        state.venue = venue;
    },
    rounds(state, rounds) {
        state.rounds = rounds;
    },
    currentRound(state, round) {
        state.currentRound = round;
    },
    roundInProgress(state, roundInstance) {
        state.roundInProgress = roundInstance;
        if (!!roundInstance) {
            localStorage.setItem('bitacorapp_round_in_progress', JSON.stringify(roundInstance));
        } else {
            localStorage.removeItem('bitacorapp_round_in_progress');
        }
    },
    inProgress(state, status) {
        state.inProgress = status;
    },
    currentPoint(state, point) {
        state.currentPoint = point;
    },
    checklistAnswers(state, answers) {
        state.checklistAnswers = answers;
    },
    lastRound(state, round) {
        state.lastRound = round;
    },
    clearState(state) {
        const s = initialState();
        Object.keys(s).map(key => state[key] = s[key]);
    },
    drawer(state, drawer) {
        state.drawer = drawer;
    },
    lastAnnotations(state, annotations) {
        state.lastAnnotations = annotations;
    },
    updateAvailable(state, val) {
        state.updateAvailable = !!val;
    },
    lastRounds(state, lastRounds) {
        state.lastRounds = lastRounds;
    },
    state(state, val) {
        Object.keys(val).map(key => state.hasOwnProperty(key) && (state[key] = val[key]));
    },
    openRounds(state, rounds) {
        state.openRounds = rounds
    }
};
